// var router = {};
export default {
	install(Vue) {
		// Vue.prototype.$f7router = router;
		// Vue.prototype.$installRouter = function(obj) {
		// 	for (let key in obj) {
		// 		router[key] = obj[key];
		// 	}
		// }
	}
}
